import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const LogoButton = ({ Icon, onClick, tooltip, style, size, disabled }) => {
    return (
        <OverlayTrigger
        placement="top" // Position of the tooltip
        overlay={<Tooltip>{tooltip}</Tooltip>}
      >
        <Icon size={size} style={style} onClick={onClick} disabled={disabled} />
    </OverlayTrigger>



    );
};

export default LogoButton;